<template>
  <div class="search">
    <div class="container">
      <div class="row">
        <h1 class="mt-4">Categories</h1>
      </div>
      <div class="row mt-3">
        <div
          style="cursor: pointer"
          @click="navigate(cat._id, cat.name)"
          v-for="cat in colorsAdd"
          v-bind:key="cat._id"
          class="col-12 col-sm-12 col-md-4 col-lg-3"
        >
          <div
            class="brands-classes"
            v-bind:style="{
              backgroundImage:
                'linear-gradient(to right,' +
                cat.first +
                ',' +
                cat.second +
                ' )',
            }"
          >
            <img
              class="zoomIn"
              style="padding: 1px"
              width="70%"
              v-bind:src="
                'https://ardunic-images.s3.eu-central-1.amazonaws.com/' +
                  cat.image
              "
              alt
            />
          </div>
          <h3 style="cursor: pointer">{{ cat.name }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import axios from "axios";
export default {
  data() {
    return {
      categories: [],
      colors: [
        { first: "#ff0400", second: "#ffcf69" },
        { first: "#c7f1ff", second: "#00d6ff" },
        { first: "#02b718", second: "#00d6ff" },
        { first: "#f16522", second: "#ffcf69" },
        { first: "#ff2cc6", second: "#ffcf69" },
      ],
    };
  },
  created() {
    this.getCategories();
  },
  computed: {
    colorsAdd() {
      return this.categories.map((cat) => {
        const randomGradiant = this.colors[
          Math.floor(Math.random() * this.colors.length)
        ];
        const colors = {
          first: randomGradiant.first,
          second: randomGradiant.second,
        };
        Object.assign(cat, colors);
        return cat;
      });
    },
  },
  methods: {
    navigate(id, name) {
      router.push({ path: `/sub/${name}/${id}` });
      // console.log(slug);
    },
    getCategories() {
      axios.get("https://api.ardunic.com/v1/sections").then((res) => {
        this.categories = res.data.data.filter((cat) => {
          return cat.isActive;
        });
      });
    },
  },
};
</script>

<style scoped>
.col-md-3 {
  text-align: center;
}

.brands-classes {
  width: 255px;
  height: 180px;
  padding: 15px;
  border: none;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.search {
  margin-top: 90px;
}
.cards-display-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.btn {
  border-radius: 15px;
}

@media (max-width: 767px) {
  #search-cards-row {
    padding: 0px;
  }
  #list-col {
    max-width: 100%;
  }
}

.filters {
  list-style: none;
  text-align: center;
}
.filters .filter-iteam {
  /* background: #c1c2c5; */
  margin: 5px;
  width: 200px;
  border-radius: 15px;
  font-size: 1.2rem;
  color: white;
}
.grey {
  background: #c1c2c5;
}

.botn {
  font-size: 20px;
  border-radius: 20px;
  outline: none;
  width: 400px;
  height: 60px;
  font-weight: bold;
}
.botn-blue {
  color: white;
  text-align: center;
  background: linear-gradient(to right, #f6893a, #fdbd5d);
}

.org {
  background: linear-gradient(right, #ff3fbb, #ff8891);
}

.blue {
  background: linear-gradient(to right, #05cefc, #5659ce);
}
.view-more {
  position: relative;
  top: -30px;
}

.filterBy {
  border-radius: 15px;
  border: 1px solid #c1c2c5;
}

#search {
  border-radius: 15px;
  border: 1px solid #c1c2c5;
  font-size: 30px;
  color: black;
}
/* .filters {
  text-align: center;
  margin: 0 auto;
} */

.card-new {
  margin-bottom: 13px;
  border-radius: 10px;
  padding: 12px 12px;
  overflow: hidden;
  box-shadow: none !important;
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.img-new {
  width: 100%;
}

.img-div {
  position: relative;
  text-align: center;
  margin-bottom: 10px;
  line-height: 0;
  width: 100%;
  overflow: hidden;
}

.card-img-new {
  max-height: 100%;
  max-width: 100%;
}

.title-new {
  height: auto;
  line-height: 18px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: black;
  font-size: 14px;
  font-weight: bold;
}

.price-new {
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-span {
  margin-right: 4px;
  font-size: 16px;
  font-weight: 700;
  height: 18px;
  line-height: 18px;
  color: #333;
  vertical-align: middle;
  font-weight: 700;
}
</style>
